import { Button } from 'bold-ui'
import { usePecField } from 'components/form/final-form/hooks/useField'
import React from 'react'
import { Meta } from 'util/metaPath'

interface CheckButtonFieldProps {
  name: Meta<number | string>
  originalValue?: number
  children: any
  disabled?: boolean
  dataTestId?: string
}

export default function CheckButtonField({
  name,
  originalValue,
  children,
  disabled,
  dataTestId,
}: CheckButtonFieldProps) {
  const {
    input: { value, onChange },
  } = usePecField({ name })

  return (
    <div>
      <Button
        onClick={() => onChange(originalValue)}
        kind={value === originalValue ? 'primary' : 'normal'}
        skin='default'
        size='small'
        disabled={disabled}
        data-cy={dataTestId}
      >
        {children}
      </Button>
    </div>
  )
}
